PegasusTemplate.CloseButtonController = Em.Controller.extend({
  needs: ['toolbar'],
  contextWidthBinding: Em.Binding.oneWay('controllers.toolbar.selectedTemplateWidth'),
  contextAlignmentBinding: Em.Binding.oneWay('controllers.toolbar.selectedCloseAlignment'),
  isAlignCloseLeftBinding: Em.Binding.oneWay('controllers.toolbar.isAlignCloseLeft'),
  isAlignCloseRightBinding: Em.Binding.oneWay('controllers.toolbar.isAlignCloseRight'),
  selectedCloseButtonBinding: Em.Binding.oneWay('controllers.toolbar.selectedCloseButton'),
  closeButtonURL: function(){
    return '/pegasus_template/assets/' + this.get('selectedCloseButton');
  }.property('selectedCloseButton')
});
